import React from "react";
import { Machine, assign } from "xstate";
import { useMachine } from "@xstate/react";
import { storage, db } from "../../fire";
import styles from "./index.module.css";
import { MDBBtn, MDBIcon } from "mdbreact";

const audioMachine = Machine(
  {
    id: "audio",
    initial: "idle",
    context: {
      audios: []
    },
    states: {
      idle: {
        on: {
          UPLOAD: {
            target: "uploading"
          },
          DELETE: {
            target: "deleting"
          }
        }
      },
      uploading: {
        on: {
          SUCCESS: {
            target: "updated",
            actions: ["addAudio"]
          }
        }
      },
      deleting: {
        on: {
          SUCCESS: {
            target: "updated",
            actions: ["removeAudio"]
          }
        }
      },
      updated: {
        on: {
          CLEAR: "idle"
        }
      }
    }
  },
  {
    actions: {
      addAudio: assign({
        audios: (ctx, evt) => [...ctx.audios, evt.data]
      })
    }
  }
);

export const AudioModal = props => {
  const [current, send] = useMachine(
    audioMachine.withContext({
      audios: props?.module?.audios ?? []
    })
  );
  const { context } = current;
  const audioElmRef = React.useRef();
  const isUploading = current.matches("uploading");
  const isDeleting = current.matches("deleting");

  React.useEffect(() => {
    console.log(current.value);
    console.log("Audio", props);
  }, [current]);

  React.useEffect(() => {
    requestUpdateModule();
  }, [current]);

  async function requestUpdateModule() {
    if (current.matches("updated")) {
      send("CLEAR");

      if (typeof props.onAudioUpdated !== "function") return;
      const module = props.module;

      props.onAudioUpdated({
        audios: context.audios,
        module
      });
    }
  }

  const doUpload = React.useCallback(async e => {
    const [file] = e.target.files;
    try {
      send("UPLOAD");

      if (audioElmRef.current) {
        audioElmRef.current.pause();
      }

      const audioRef = storage.ref().child(`/audio/${file.name + Date.now()}`);

      await audioRef.put(file);

      const { name } = await audioRef.getMetadata();

      const url = await audioRef.getDownloadURL();

      const newAudio = {
        name,
        url
      };

      await props.service.objetoResultadoRef
        .collection(props.currentViewOption)
        .doc(props.module.codigo)
        .update({ audios: [...context.audios, newAudio] });

      send({
        type: "SUCCESS",
        data: newAudio
      });
    } catch (error) {
      console.log({ error });
    }
  });

  const deleteAudio = React.useCallback(async audioData => {
    const audioRef = storage.ref().child(`audio/${audioData.name}`);
    try {
      send("DELETE");

      await audioRef.delete();

      context.audios.splice(
        context.audios.findIndex(audio => audio.url === audioData.url),
        1
      );

      await props.service.objetoResultadoRef
        .collection(props.currentViewOption)
        .doc(props.module.codigo)
        .update({ audios: context.audios });

      send({
        type: "SUCCESS",
        data: audioData
      });
    } catch (error) {
      context.audios.splice(
        context.audios.findIndex(audio => audio.url === audioData.url),
        1
      );

      await props.service.objetoResultadoRef
        .collection(props.currentViewOption)
        .doc(props.module.codigo)
        .update({ audios: context.audios });

      send({
        type: "SUCCESS",
        data: audioData
      });

      console.log({ error });
    }
  });

  const requestClose = () => {
    if (isDeleting || isUploading) return;

    props.onRequestClose && props.onRequestClose();
  };

  if (!props.open) return null;

  return (
    <div
      className={styles.container}
      onClick={e => {
        if (e.target !== e.currentTarget) return;
        requestClose();
      }}
    >
      <div className={styles["modal-body"]}>
        <h1>
          Lista de áudios
          <MDBIcon
            icon="times"
            onClick={requestClose}
            className={styles.close}
          />
        </h1>
        {(isUploading || isDeleting) && (
          <div className={styles.status}>
            {isUploading && "Enviando..."}
            {isDeleting && "Atualizando lista de áudios"}
          </div>
        )}
        {isUploading || isDeleting ? null : (
          <input type="file" onChange={doUpload} accept="audio/*" />
        )}

        {context.audios.map((audio, i) => (
          <div className={styles.item}>
            <audio
              key={audio + i}
              controls
              src={audio.url}
              onPlay={e => {
                audioElmRef.current = e.target;
              }}
            >
              {console.log(audio)}
              Seu navegador não tem suporte ao elemento
              <code>audio</code>.
            </audio>
            <MDBBtn
              disabled={isUploading || isDeleting}
              onClick={() => deleteAudio(audio)}
              color="red darken-3"
              size="sm"
            >
              Apagar
            </MDBBtn>
          </div>
        ))}
      </div>
    </div>
  );
};
